// extracted by mini-css-extract-plugin
export default {"root":"CharacterList_root__lamLc","breadcrumbs":"CharacterList_breadcrumbs__obdv0","pagination":"CharacterList_pagination__i46-u"};